<template>
  <div class="modal body-scrollbar-locker" @mousedown.self="close">
    <div class="modal__container">
      <i v-if="showCloseIcon" class="icon-close modal__close" @mousedown="close" />
      <slot />
      <loader v-if="isLoading" :inline="true" />
    </div>
  </div>
</template>
<script>
import { useScrollbarLock } from '@/composables/useScrollbarLock'

export default {
  name: 'Modal',
  props: {
    isClosable: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
  setup() {
    const { lockScrollbar, unlockScrollbar } = useScrollbarLock()

    return {
      lockScrollbar,
      unlockScrollbar,
    }
  },
  mounted() {
    document.documentElement.style['scrollbar-color'] = '#a1a1a1 #a1a1a1'
    this.lockScrollbar()
  },
  beforeUnmount() {
    document.documentElement.style['scrollbar-color'] = ''
    this.unlockScrollbar()
  },
  methods: {
    close(e) {
      if (this.isClosable) this.$emit('close', e)
    },
  },
}
</script>
